import { useLocale } from '@/hooks/useLocale';
import { LegalPageLayout } from '@/components/LegalPageLayout';
import { getLegalBundle } from '@/data/legal';

export default function PrivacyPolicy() {
  const { lang } = useLocale();
  return <LegalPageLayout docType="privacy" bundle={getLegalBundle(lang)} />;
}
